import { Box, Button, FormControl,InputLabel, MenuItem, Select} from '@mui/material';
import React, { useEffect, useState } from 'react';
import * as PXBColors from '@brightlayer-ui/colors';
import AddIcon from '@mui/icons-material/Add';
import { LocationAutoComplete } from '../LocationAutoComplete/LocationAutoComplete';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { RoleLocationList, SiteInfo, UserRole } from '../../types';
import { addMoreRoleLocations, otherLocationSelectedList, updatedRoleList } from '../../lib/user-helpers';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import _ from 'lodash';

type Props = {
    roleData: Array<{
        roleId: string;
        roleName: string;
    }>;
    existingLocation: SiteInfo[];
    onRoleChange: Function;
    removeAddRow: Function;
    onSelectLocation: Function;
    AddRow: Function;
    isEdit: boolean;
};

export const RoleLocation: React.FC<Props> = (props) => {
    const { t } = useLanguageLocale();
    const [showLocation, setShowLocation] = useState(false);
    const [showMoreButton, setShowMoreButton] = useState(false);
    const selectedOrganization = useSelectedOrganizationData();
    const orgName = isRecordFound(selectedOrganization) ? selectedOrganization.value.name : '';
    const orgId = isRecordFound(selectedOrganization) ? selectedOrganization.value.id : '';

    const [addRoleLocationList, setAddRoleLocationList] = useState<RoleLocationList>([
        {
            index: 0,
            roleId: '',
            disabledLocations: [],
            roleList: props.roleData.filter((x) => x.roleName !== UserRole.Unassigned),
            selectedLocation: [],
        },
    ]);
    useEffect(() => {
        const value: SiteInfo[] = _.flatten(addRoleLocationList.map((x) => x.selectedLocation));

        const updateDisableInAdd = [...addRoleLocationList];
        const update = updateDisableInAdd.map((x) => {
            const disable = [...props.existingLocation, ...value];
            return {
                index: x.index,
                roleId: x.roleId,
                disabledLocations: disable.filter((y) => !x.selectedLocation.includes(y)),
                roleList: x.roleList,
                selectedLocation: x.selectedLocation,
            };
        });
        setAddRoleLocationList(update);
    }, [props.existingLocation]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleChangeAddRole = (
        event: any, // eslint-disable-line @typescript-eslint/no-explicit-any
        roleData: Array<{ roleId: string; roleName: string }>,
        index: number
    ): void => {
        const selectedRole = roleData.find((a) => a.roleId === event.target.value);
        let obj = [...addRoleLocationList];
        if (selectedRole && selectedRole.roleName === UserRole.EatonAdmin) {
            obj = [
                {
                    index: 0,
                    roleId: event.target.value,
                    disabledLocations: [],
                    roleList: props.roleData.filter((x) => x.roleName !== UserRole.Unassigned),
                    selectedLocation: [],
                },
            ];
            setShowLocation(false);
            setShowMoreButton(false);
        } else if (selectedRole && selectedRole.roleName === UserRole.OrgAdmin) {
            /** special case for org admin on select org admin location ddl is hidden and selected locqation should have orgId */
            obj = [
                {
                    index: 0,
                    roleId: event.target.value,
                    disabledLocations: [],
                    roleList: props.roleData.filter((x) => x.roleName !== UserRole.Unassigned),
                    selectedLocation: [{ siteId: orgId, siteName: orgName }],
                },
            ];
            setShowLocation(false);
            setShowMoreButton(false);
        } else {
            obj[index].roleId = event.target.value;
            obj[index].selectedLocation =
                obj[index].selectedLocation.length === 1 && obj[index].selectedLocation[0].siteId === orgId
                    ? []
                    : obj[index].selectedLocation;

            const result = otherLocationSelectedList(index, obj);
            const disable = [...result, ...props.existingLocation];
            obj[index].disabledLocations = disable;
            /** hide the add role/location button when there is only one role is exist in the ddl */
            const latestRoleList = addRoleLocationList[addRoleLocationList.length - 1].roleList;
            if (latestRoleList.length === 1) setShowMoreButton(false);
            setShowLocation(true);
        }
        if (!selectedRole) {
            setShowLocation(false);
            setShowMoreButton(false);
        }
        setAddRoleLocationList(obj);
        props.onRoleChange(obj);
    };

    const removeRoleLocation = (index: number): void => {
        const removeObj = [...addRoleLocationList];
        const otherLocationList = removeObj.filter((x) => x.index !== index);
        /** set disabled value in the autocomplete */
        if (otherLocationList.length > 0) {
            removeObj[otherLocationList[0].index].disabledLocations = [];
        }
        removeObj.splice(index, 1);
        setShowMoreButton(true);
        setAddRoleLocationList(removeObj);
        props.removeAddRow(removeObj);
    };
    const selectedLocations = (value: {
        index: number;
        selectedlocation: Array<{
            siteId: string;
            siteName: string;
        }>;
    }): void => {
        const obj = [...addRoleLocationList];
        obj[value.index].selectedLocation = value.selectedlocation.map((x: SiteInfo) => ({
            siteId: x.siteId,
            siteName: x.siteName,
        }));
        const otherLocationList = obj.filter((x) => x.index !== value.index);

        /** set disabled value in the autocomplete */
        if (otherLocationList.length > 0) {
            const associtedLocation: SiteInfo[] = props.existingLocation; //associatedLocation(modifiedRoleData);
            const selectedValue = value.selectedlocation.map((x: SiteInfo) => ({
                siteId: x.siteId,
                siteName: x.siteName,
            }));
            obj[otherLocationList[0].index].disabledLocations = [...associtedLocation, ...selectedValue];
        }
        setAddRoleLocationList(obj);
        props.onSelectLocation(obj);
        if (value.selectedlocation.length > 0) setShowMoreButton(true);
        /** hide the add role/location button when there is only one role is exist in the ddl */
        const latestRoleList = addRoleLocationList[addRoleLocationList.length - 1].roleList;
        if (latestRoleList.length === 1) setShowMoreButton(false);
    };
    const addAdditionalLocation = (): void => {
        const updatedRoles = updatedRoleList(addRoleLocationList, props.roleData);
        //const associtedLocation: SiteInfo[] = associatedLocation(modifiedRoleData);
        const newArray = addMoreRoleLocations(addRoleLocationList, updatedRoles, props.existingLocation);

        setAddRoleLocationList(newArray);
        props.AddRow(newArray);
        /** hide the add role/location button when there is only one role is exist in the ddl */
        if (updatedRoles.length === 1) {
            setShowMoreButton(false);
        }
    };
    return (
        <Box>

            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
            {addRoleLocationList.map((data: any, index: number) => (
                <Box style={{ display: "flex", flexDirection: "column", alignItems: "left", marginTop: 15 }} key={data.index}>
                    <FormControl   variant="filled" required>
                        <InputLabel id="roleData" data-testid="role-label">
                            {t('ADDUSER.SELECTROLE')}
                        </InputLabel>
                        <Select
                        style={{ marginBottom: 24 }}
                            label="Role"
                            fullWidth
                            onChange={(e): void => {
                                handleChangeAddRole(e, props.roleData, index);
                            }}
                            value={data.roleId}
                            required
                            inputProps={{
                                'data-testid': 'role-dd',
                            }}
                            key={index}
                        >
                            {data.roleList.map((roleData: { roleId: string; roleName: string }) => (
                                <MenuItem data-testid="role-menu" key={roleData.roleId} value={roleData.roleId}>
                                    {roleData.roleName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {showLocation && (
                        <>
                            <LocationAutoComplete
                                index={data.index}
                                selectedLocation={data.disabledLocations}
                                updatedLocation={selectedLocations}
                            />
                            {addRoleLocationList.length > 1 && index !== 0 && (
                                <Box
                                style={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                
                                }}
                            >
                               <Button startIcon={<DeleteIcon />} style={{
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    color: PXBColors.gray[200]
                                }} onClick={(): void => {
                                    removeRoleLocation(index);
                                }}>
                                    Remove this assignment
                                </Button>
                            </Box>
                                
                            )}
                        </>
                    )}
                </Box>
            ))}
            {showLocation && showMoreButton && (
                <Box
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                    
                    }}
                >
                   <Button color="primary" startIcon={<AddIcon />} style={{
                        fontWeight: 600,
                        textTransform: 'none'
                    }} onClick={addAdditionalLocation}>
                        Add Additional Roles
                    </Button>
                </Box>
            )}
        </Box>
    );
};
